import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Card
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Snackbar from '@mui/material/Snackbar';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput } from '../../reusableComponent/ErpTextField';
import { addBin, editDeleteBin } from '../../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

function BinAdd(props) {
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    // const editInfo = props.details;
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const editData = editInfo && editInfo;
    const editid = editData && editData.id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);

    const [data, setData] = useState({
        id: editid,
        binNo: editData ? editData.binNo : '',
        rackNo: editData ? editData.rackNo : '',
        storeName: editData ? editData.storeName : '',

    });

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (editData) {
            if (reason !== 'backdropClick') {
                setOpen(false);
            }
        } else {
            if (data.binNo == '') {
                setOpen(false);
                setOpenSnak(false);
            } else {
                setOpenSnak(true)
            }
        }
    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setData({
            binNo: '',
            rackNo: '',
            storeName: '',
        })
        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.bin.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);

        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Category name already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);


    const clearInputFields = () => {
        setData({
            binNo: '',
            rackNo: '',
            storeName: '',
        });
    };
    const onSubmit = (event) => {
        const binData = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteBin(binData));
        } else {
            dispatch(addBin(binData));
        }
        // props.onAPISubmt();
        // props.handleCloseDialog();
    }

    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );


    return (
        <>
            <div>
            <Breadcrumb
                            routeSegments={[
                                { name: 'Masters', path: '/masters/' },
                                { name: 'Bin List', path: '/masters/bin-masters' },
                                { name: 'Create Bin' },
                            ]}
                        />
                <Paper className={`${styles.list_container}`}>
                  
                    {/* <Box sx={{ display: 'flex' ,paddingLeft:'50px'}}>
                        <Grid container spacing={0.2} sx={{ mt: 2, pb: 2 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create New Bin</Typography>
                            </Grid>

                        </Grid>
                    </Box> */}
                     <Box sx={{ m: 4}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box style={{paddingLeft:'50px'}}>
                            <Grid container spacing={2} style={{ minHeight: '350px' }}>
                                <Grid item xs={4} >
                                    <Typography > Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} ></Grid>
                                <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <Card className={`${styles.m_card}`}>
                                        <Grid container spacing={2} >
                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Bin No</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    fullWidth
                                                    size='small'
                                                    name="binNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.binNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Rack No</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    fullWidth
                                                    size='small'
                                                    name="rackNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.rackNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={3} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Store Name</Typography>
                                            </Grid>
                                            <Grid item xs={9} className={`${styles.grid_input}`}>
                                                <ERPinput
                                                    fullWidth
                                                    size='small'
                                                    name="storeName"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.storeName)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                            <Box sx={{ marginTop: '12px', float: 'right' }}>
                                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                            </Button>
                                            <Cancel />
                                        </Box>

                                            </Grid>
                                        </Grid>
                                     
                                    </Card>
                                </Grid>
                            </Grid>
                         
                        </Box>
                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
                   {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}
export default BinAdd